<template>
    <modal
        :value="show"
        :headline="headline"
        @input="$emit('input', $event)"
    >
        <slot />

        <template #footer>
            <app-button
                size="small"
                theme="default"
                :disabled="isLoading"
                @click.native="$emit('input', false)"
            >Abbrechen</app-button>

            <app-button
                ref="submit"
                size="small"
                :is-loading="isLoading"
                @click.native="onConfirm"
            >{{ confirmLabel }}</app-button>
        </template>
    </modal>
</template>

<script>
import Modal from '@/components/ui/Modal.vue'
import AppButton from '@/components/ui/Button.vue'

export default {
    name: 'ConfirmModal',

    components: { Modal, AppButton },

    props: {
        value: { type: Boolean, required: true },
        headline: { type: String, required: true },
        confirmLabel: { type: String, default: 'OK' },
        isLoading: { type: Boolean, default: false },
    },

    data () {
        return {
            show: this.value,
        }
    },

    watch: {
        value (value) {
            this.show = value
        },
    },

    mounted () {
        this.$refs?.submit?.$el?.focus()
    },

    methods: {
        onConfirm () {
            if (this.isLoading) return

            this.$emit('confirm')
        },
    },
}
</script>
